import { render, staticRenderFns } from "./PointList.vue?vue&type=template&id=61f9dbfd&"
import script from "./PointList.vue?vue&type=script&lang=ts&"
export * from "./PointList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports